import { SnackbarProvider } from 'notistack';
import type { PropsWithChildren } from 'react';
import React from 'react';

const ToastProvider = ({ children }: PropsWithChildren) => {
  return (
    <SnackbarProvider maxSnack={3} autoHideDuration={3000}>
      {children}
    </SnackbarProvider>
  );
};

export default ToastProvider;
